export * from './api';
export * from './async';
import * as Selectors from './selectors';
import { apiSlice } from './slice';

const Actions = apiSlice.actions;
const Reducer = apiSlice.reducer;

export { Actions, Selectors, Reducer };
